<template>
  <div class="box-container">
    <div class="header">
      <h2 class="title">功能模块</h2>
    </div>
    <div class="divider"></div>
    <div class="box-menu">
      <!-- 会员入口（前两个按钮） -->
      <div class="box-menu-item" v-for="(item, i) in list.slice(0, 2)" :key="i" @click="gotoMenberManagement(item)">
        <img src="../../assets/icon/成员.png" />
        <span>{{ item.label }}</span>
      </div>

      <!-- 联系方式 -->
      <div class="box-menu-item" @click="gotolianxi">
        <img src="../../assets/icon/客服.png" />
        <span>{{ list[2].label }}</span>
      </div>

      <!-- 二维码 -->
      <div class="box-menu-item" @click="gotoQRCodePage">
        <img src="../../assets/icon/扫描.png" />
        <span>{{ list[3].label }}</span>
      </div>
      <!-- 下载专区 -->
      <div class="box-menu-item" @click="gotodown">
        <img src="../../assets/icon/下载.png" />
        <span>{{ list[4].label }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import router from '@/router';

const list = ref([
  { value: 0, label: '山东省神经科学学会会员入口' },
  { value: 1, label: '山东省阿尔茨海默病防治协会会员入口' },
  { value: 2, label: '联系我们' },
  { value: 3, label: '微信二维码' },
  { value: 4, label: '下载专区' },
]);

// 会员入口跳转（前两个按钮）
const gotoMenberManagement = (item: any) => {
  if (item.value === 0) {
    window.location.href = 'https://member.tiemeeting.com/3/Mpersonal/Account/Login';
    return;
  }
  sessionStorage.removeItem('phone');
  sessionStorage.removeItem('numberIdx');
  router.push({
    path: `/menberLogin`,
    query: { id: item.value }
  });
};

// 联系我们跳转
const gotolianxi = () => {
  router.push('/learnOpen');
};

// 二维码页面跳转
const gotoQRCodePage = () => {
  router.push('/weixin'); // 替换为你的二维码页面路由
};
// 下载专区
const gotodown = () => {
  router.push('/learnZone'); // 替换为你的二维码页面路由
};
</script>

<style lang="scss" scoped>
.box-container {
  width: 100%;
  background: white;
  place-items: center;
  padding-top: 1rem;
  padding-bottom: 1rem;
  position: relative;
}

.header {
  width: 100%;
  padding: 1.5rem 0 0;
  position: relative;
  text-align: center;
}

.title {
  font-weight: 700;
  font-size: 1.3rem;
  color: #1373C0;
  cursor: default;
  padding: 0 0.5rem 0.5rem;
  height: auto;
  line-height: 1.5;
  position: relative;
  margin-bottom: 1rem;
  width: 100%;
}

.divider {
  height: 1px;
  width: 95%;
  background: linear-gradient(90deg, rgba(19, 115, 192, 0.2), rgba(19, 115, 192, 0.05));
  margin-top: 0.5rem;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    bottom: 100%; // 放在灰色线的正上方
    // left: -400px;
    width: 100%; // 横跨整个宽度
    height: 3px;
    background: linear-gradient(90deg, #1373C0, #4da7f0);
    border-radius: 2px;
  }
}

.box-menu {
  // background-color: #4da7f062;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.9), rgba(242, 247, 252, 0.9));
  width: 95%;
  max-width: 1200px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 1rem;
  place-items: center;
  margin: 0 auto;
  padding: 1.5rem;
  /* 增加内边距防止内容贴边 */
  box-sizing: border-box;
  /* 确保padding不影响总宽度 */

  .box-menu-item {
    width: 110px;
    min-width: 0;
    height: auto;
    aspect-ratio: 1/1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    // font-weight: 700;
    color: #fff;
    // background-color: #1373C0;
    background: linear-gradient(135deg, #1373C0, #4da7f0);
    border-radius: 12px;
    cursor: pointer;
    text-align: center;
    padding: 1rem;
    transition: all 0.3s ease;
    box-shadow: 0 4px 8px rgba(19, 115, 192, 0.15);
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: -50%;
      left: -50%;
      width: 200%;
      height: 200%;
      background: linear-gradient(to bottom right,
          rgba(255, 255, 255, 0.3) 0%,
          rgba(255, 255, 255, 0) 60%);
      transform: rotate(30deg);
      transition: all 0.5s ease;
    }

    img {
      width: 36px;
      height: 36px;
      margin-bottom: 0.8rem;
      filter: brightness(0) invert(1);
      transition: transform 0.3s ease;
    }

    /* 文字响应式设置 */
    span {
      font-weight: 600;
      color: white;
      text-align: center;
      font-size: 0.9rem;
      line-height: 1.3;
      z-index: 1;
    }

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 8px 20px rgba(19, 115, 192, 0.25);

      &::before {
        transform: rotate(30deg) translate(10px, 10px);
      }

      img {
        transform: scale(1.1);
      }
    }
  }



  /* 小屏幕适配 */
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    /* 小屏幕改为2列 */
    gap: 0.8rem;

    .box-menu-item {
      aspect-ratio: 1/1;
      /* 方形按钮 */
      padding: 0.8rem;

      img {
        width: 35%;
        margin-bottom: 0.5rem;
      }

      span {
        font-size: clamp(10px, 1.5vw, 14px);
      }
    }

    .divider {
      height: 1px;
      width: 100% !important;
    }
  }

  /* 超小屏幕适配 */
  // @media (max-width: 480px) {
  //   grid-template-columns: 1fr;
  //   // grid-template-columns: rsepeat(1, 1fr);
  //   /* 单列布局 */
  //   width: 100%;


  //   .box-menu-item {
  //     aspect-ratio: unset;
  //     min-height: 80px;
  //     flex-direction: row;
  //     /* 改为横向排列 */
  //     justify-content: flex-start;
  //     padding: 0.8rem 1.2rem;
  //     // font-size: 20px !important;

  //     img {
  //       width: 30px;
  //       height: 30px;
  //       margin-bottom: 0;
  //       margin-right: 0.8rem;
  //     }
  //   }

  //   .divider {
  //     height: 1px;
  //     width: 100% !important;
  //   }
  // }
}
</style>